import React, { FC } from 'react';
import { Typography } from '@mui/material';
import InfoTooltip from '@components/info-tooltip/info-tooltip.tsx';
import { ChartWrapperProps } from '@shared/models/charts/chart-wrapper.model.ts';

const ChartWrapper: FC<ChartWrapperProps> = ({
  title,
  description,
  tooltipText,
  children
}) => {
  return (
    <div className="w-full rounded-[13px] bg-(--gray-11) px-4 pb-6 pt-8">
      <div className="w-full flex items-start justify-between mb-7">
        <div className="w-full">
          <div className="flex justify-between items-center gap-6 mb-2">
            <Typography variant="subtitle2" className="max-lg-xl:text-[18px]!">
              {title}
            </Typography>
            {tooltipText && <InfoTooltip text={tooltipText} />}
          </div>
          {description && (
            <Typography
              variant="body1"
              className="opacity-50! max-lg-xl:text-[14px]!"
            >
              {description}
            </Typography>
          )}
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
};

export default ChartWrapper;
